import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import Spinner from "@/common/components/Spinner";
import { useDashboard } from "../../hooks/dashboards/useDashboard";
import { DashboardData } from "../../types/dashboards/dashboard.type";
import DashboardGrid from "./DashboardGrid";
import DashboardHeader from "./DashboardHeader";
import EmptyDashboardComponents from "./EmptyDashboardComponents";

interface DashboardProps {
  dashboardListItem: DashboardData;
  initialWidth: number;
  isCreator: boolean;
  hasPermissionToUpdateDashboard: boolean;
}

const Dashboard = ({
  dashboardListItem,
  initialWidth,
  isCreator,
  hasPermissionToUpdateDashboard,
}: DashboardProps) => {
  const {
    data: dashboard,
    isPending: dashboardIsPending,
    dataUpdatedAt: dashboardUpdatedAt,
    error: dashboardError = {} as any,
    refetch: refetchDashboard,
  } = useDashboard(dashboardListItem.id);

  if (dashboardIsPending) {
    return (
      <div className="flex-1 flex flex-col gap-4 items-center justify-center h-full">
        <Spinner />

        <p>
          Carregando...
        </p>
      </div>
    );
  }

  if (!dashboard || !dashboard.components?.length) {
    return (
      <ErrorMessageWrapper
        className="flex-1 flex flex-col"
        statusCode={dashboardError?.status}
        refetchFunction={refetchDashboard}
      >
        <DashboardHeader
          dashboard={dashboardListItem}
          dashboardUpdatedAt={0}
          isCreator={isCreator}
          hasPermissionToUpdateDashboard={hasPermissionToUpdateDashboard}
        />

        <EmptyDashboardComponents
          isCreator={isCreator}
          dashboardId={dashboardListItem.id}
        />
      </ErrorMessageWrapper>
    );
  }

  return (
    <DashboardGrid
      dashboard={dashboard}
      dashboardUpdatedAt={dashboardUpdatedAt}
      initialWidth={initialWidth}
      isCreator={isCreator}
      hasPermissionToUpdateDashboard={hasPermissionToUpdateDashboard}
    />
  );
}

export default Dashboard;
